import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import BasketLineItemImage from "@/ui/views/checkout/BasketLineItemImage.vue";
import BasketLineItemPrice from "@/ui/views/checkout/BasketLineItemPrice.vue";
import BasketLineItemQuantity from "@/ui/views/checkout/BasketLineItemQuantity.vue";
import BasketLineItemRemove from "@/ui/views/checkout/BasketLineItemRemove.vue";
import BasketLineItemProperties from "@/ui/views/checkout/BasketLineItemProperties.vue";
import BasketLineItemTitle from "@/ui/views/checkout/BasketLineItemTitle.vue";
import UpdateLineItemWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateLineItemWebRequest;
import RemoveFromBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.RemoveFromBasketWebRequest;
import { BasketType } from "@/enums";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemB2C',
  props: {
    lineItem: null,
    vatText: null
  },
  setup(__props: any) {

const props = __props as {
    lineItem: LineItemViewObject,
    vatText: string
}



const isBasketLocked = computed<boolean>(() => store.getters["basket/isBasketLocked"]);

function removeFromBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch("basket/removeFromBasket", request);
}

function updateLineItem(request: UpdateLineItemWebRequest) {
    store.dispatch("basket/updateLineItem", request);
}


function remove(lineItemId: number) {
    removeFromBasket({ id: lineItemId, basketType: BasketType.B2C as any });
}

function onQuantityChange(quantity: number) {
    if (quantity === props.lineItem.quantity) {
        return;
    }
    updateLineItem({ id: props.lineItem.lineItemId, quantity, discountPercent: null, basketType: BasketType.B2C as any });
}


return { __sfc: true,props, isBasketLocked, removeFromBasket, updateLineItem, remove, onQuantityChange, BasketLineItemImage, BasketLineItemPrice, BasketLineItemQuantity, BasketLineItemRemove, BasketLineItemProperties, BasketLineItemTitle }
}

})